import React, { useState, useEffect } from 'react';
import LoadingOverlay from '../LoadingOverlay';
import { IPersistGateProps } from './types';
import { startSessionKeeper, stopSessionKeeper } from '../../services/auth/sessionRefresh';

const PersistGate: React.FC<IPersistGateProps> = (props:IPersistGateProps) => {
  const { children, liftSession } = props;
  const [isSessionLifted, setSessionLifted] = useState(false);

  useEffect(() => {
    liftSession().then(() => setSessionLifted(true));

    // O liftSession só roda na subida do app. Sem o relógio, o access token de 5
    // minutos expira e a sessão morre com o usuário na tela (C4).
    startSessionKeeper();

    return stopSessionKeeper;
  }, []);

  if (!isSessionLifted) {
    return (
      <LoadingOverlay show />
    );
  }

  return (
    <>
      {children}
    </>
  );
};

export default PersistGate;
